import { initialState } from './selectors';
import { SET_COMPANY } from './actions';

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SET_COMPANY:
      return {
        ...state,
        ...payload,
        name: payload.name,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/company/reducer.js